import { AuthGuardService } from '@sc/pas-common';
import { AuthService, ProducerService } from 'app/core/services';
var RetirementInsuranceComponent = /** @class */ (function () {
    function RetirementInsuranceComponent(producerService, authGuardService, auth, window) {
        this.producerService = producerService;
        this.authGuardService = authGuardService;
        this.auth = auth;
        this.window = window;
        this.openMenu = false;
        this.loading = false;
    }
    RetirementInsuranceComponent.prototype.openPASSelector = function () {
        var _this = this;
        this.loading = true;
        this.producerService.getByUserID(this.authGuardService.user).subscribe(function (producers) {
            _this.producers = producers;
            _this.openMenu = true;
        });
    };
    RetirementInsuranceComponent.prototype.handleOnClickPasSelector = function (producer) {
        var _this = this;
        this.openMenu = false;
        this.auth.generateRetirementInsuranceAccess(producer.cuit).subscribe(function (response) {
            _this.window.open("" + response.url + response.jwt_token, '_blank');
        }).add(function () { return _this.loading = false; });
    };
    RetirementInsuranceComponent.prototype.closeLateralMenu = function () {
        this.loading = false;
        this.openMenu = false;
    };
    return RetirementInsuranceComponent;
}());
export { RetirementInsuranceComponent };
